export default "__VITE_ASSET__DkAfhLm___"